import React from 'react';
import { Container, Preview, Description } from './styled';

export function PreviewFile(props) {
    const { name, url, type } = props;

    const renderPreview = () => {
        if (type.includes('image')) {
            return (
                <div className='preview--img'>
                    <img src={url} alt={name} />
                </div>
            );
        } else if (type.includes('pdf')) {
            return (
                <div className='preview--pdf'>
                    <object
                        data={url}
                        type='application/pdf'
                        width='100%'
                        height='500px'
                        style={{ overflow: 'hidden' }}
                    >
                        <p>Seu navegador não suporta visualização de PDF. Você pode baixar o arquivo
                            <a href={url}>aqui</a>
                        </p>
                    </object>
                </div>
            );
        } else if (type.includes('webm')) {
            return (
                <div className='document'>
                    <div className='triangle-chamfer'></div>
                    <div className='triangle-corner'></div>
                    <div className='icon'>
                        {type.split('/').pop()}
                    </div>
                </div>
            )
        } else if (type.includes('video')) {
            return (
                <div className='preview--video'>
                    <video src={url} alt={name} />
                    <div
                        className='circle'
                        onClick={() => {
                            window.open(url, '_blank')
                        }}
                    >
                        <span
                            className='play--'
                        ></span>
                    </div>
                </div>
            )
        } else {
            return (
                <div className='document'>
                    <div className='triangle-chamfer'></div>
                    <div className='triangle-corner'></div>
                    <div className='icon'>
                        {name.split('.').pop()}
                    </div>
                </div>
            );
        }
    };


    return (
        <Container>
            <Preview>{renderPreview()}</Preview>
            <Description>
                <span>{name}</span>
            </Description>
        </Container>
    );
}